export enum Restriction {
    HCP = "hcp",
    PATIENT = "patient"
}